import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Profile from "../../components/profile";


import Banner from "../../images/team/Head_Team_2023.jpg";

const Team = () => {
    const teamdata = [
        {
            "title": "Dr. Claudia SEBALD",
            "descr": "Fachärztin für Innere Medizin und Kardiologie",
            "additional": <a href="/homepage/#/team/csebald"> Lebenslauf </a>
        },
        {
            "title": "Frau Dr. Gülay Hackl Algül",
            "descr": "FÄ für Innere und Kardiologie",
        },
        {
            "title": "Priv. Doz. Dr. Bernhard Bielesz",
            "descr": "Vertretungsarzt, Facharzt für Kardiologie, Nephrologie und Intensivmedizin",
        },
        {
            "title": "Dr. Thomas BAUER",
            "descr": "Vertretungsarzt, Facharzt für Innere Medizin, Kardiologie und Intensivmedizin"
        },
        {
            "title": "Dr. Li DO",
            "descr": "Vertretungsarzt, Facharzt für Innere Medizin und Kardiologie"
        },
        {
            "title": "Dr. Martin MOSER",
            "descr": "Vertretungsarzt, Facharzt für Innere Medizin und Angiologie"
        },
        {
            "title": "Dr. Andrei Odoviciuc",
            "descr": "Vertretungsarzt, Facharzt für Innere Medizin"
        },
        {
            "title": "Claudia KAPPEL",
            "descr": "biomed. Analytikerin, Sonographie"
        },
        {
            "title": "Milena PETROVIC",
            "descr": "Ordinationsassistentin"
        },
        {
            "title": "Christine KISS",
            "descr": "Ordinationsassistentin"
        },
        {
            "title": "Oksana DANYLENKO",
            "descr": "Ordinationsassistentin"
        },
        {
            "title": "Mag. Oliver KARLIK",
            "descr": "Ordinationsassistent"
        },
        {
            "title": "Orsolya SCHMIDT",
            "descr": "Ordinationsassistentin"
        },
        {
            "title": "Victoria LUPSIC",
            "descr": "Anmeldung"
        },
        {
            "title": "Zorica OSAP",
            "descr": "Anmeldung"
        },
        {
            "title": "Paul SEBALD",
            "descr": "Student"
        },
        {
            "title": "Noemi JAKUBOVICH",
            "descr": "Studentin"
        },
        {
            "title": "Chriptoph KICKER",
            "descr": "Student"
        },
        {
            "title": "Manuela Gruber",
            "descr": "Ordinationsassistentin"
        },
        {
            "title": "Lukas Felber",
            "descr": "Student"
        },
        {
            "title": "Anna Striednig",
            "descr": "Studentin"
        }

    ]
    const images = require.context('../../images/team/profiles', false, /\.jpg$/);

    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Team </h1>
                    {teamdata.slice(0, 2).map((person, key_id) => (<Profile images={images} key_id={key_id} object={person}/>))}
                    
                    <p className="grey-text">
                        <h4> Wiener Gebietskrankenkasse (ÖGKK) </h4>
                        Wir möchten sie darauf hinweisen, dass ÖGKK Patienten pro Quartal nur einen Internisten konsultieren können. Falls sie bereits bei einem Facharzt für Innere Medizin waren, müssen sie eine Überweisung desjenigen bringen, eine Freischaltung seitens der ÖGKK veranlassen oder vor Ort bezahlen ( je nach Aufwand).
                        <h4> Vertretungsärzte </h4>
                        In Urlaubs- / Fortbildungszeiten werde ich von KollegInnen meines Vertrauens vertreten. Diese Zusammenarbeit ermöglicht Ihnen, zusätzliche Qualifikationen und vermehrte Öffnungszeiten wahrzunehmen.
                    </p>
                    {teamdata.slice(2).map((person, key_id) => (<Profile images={images} key_id={key_id+2} object={person}/>))}
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Team;
